'use es6';

import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import promotingMenuDropTarget from 'simple-menus-lib/components/dnd/decorators/promotingMenuDropTarget';
import { jsx as _jsx } from "react/jsx-runtime";
class PromotingMenuDropTarget extends PureComponent {
  get classNames() {
    return classNames('simple-menus-promoting-drop-target', this.props.isOver && 'is--over', !this.props.canDrop && 'no--drop');
  }
  render() {
    const {
      depth,
      connectDropTarget
    } = this.props;
    return connectDropTarget( /*#__PURE__*/_jsx("div", {
      className: this.classNames
    }, depth));
  }
}
PromotingMenuDropTarget.defaultProps = {
  depth: 0,
  targetParentId: null
};
PromotingMenuDropTarget.propTypes = {
  depth: PropTypes.number.isRequired,
  connectDropTarget: PropTypes.func.isRequired,
  isOver: PropTypes.bool,
  canDrop: PropTypes.bool
};
export default promotingMenuDropTarget()(PromotingMenuDropTarget);